import { useState, useEffect } from 'react';
import { A04, A04Input, A04Output } from 'api/U002';
import { useAuth } from 'hooks/useAuth';
import { FetchError } from 'api/API';

type GetApplyFormRequest = Omit<A04Input, 'user_id_a'>;
export type GetApplyFormResponse = A04Output;
export function useGetApplyForm(
  param: GetApplyFormRequest
): [GetApplyFormResponse | null, boolean, Error | null] {
  const auth = useAuth();
  const [loading, setLoading] = useState<boolean>(true);
  const [applyForm, setApplyForm] = useState<GetApplyFormResponse | null>(null);
  const [err, setError] = useState<Error | null>(null);

  const FetchApplyForm = async (param: A04Input, cancellation: AbortSignal) => {
    const json = await A04(param, cancellation);
    return json;
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    async function fetch() {
      if (!param.audition_id && param.examination_no != null) return;
      try {
        setLoading(true);
        setError(null);
        const applyForm = await FetchApplyForm({ ...param, user_id_a: auth.username }, signal);
        setApplyForm(applyForm);
      } catch (err) {
        if (err instanceof DOMException && err.message === 'signal is aborted without reason')
          return;
        console.error({ err });
        if (err instanceof FetchError) {
          const errorData = await err.response.json();
          const flooredError = new Error(errorData.message || `HTTP ERROR: ${err.message}`);
          setError(flooredError);
        } else {
          const flooredError = new Error(`unknown error. ${err}`);
          setError(flooredError);
        }
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      controller.abort();
    };
  }, [param.audition_id, param.examination_no, param.lang, auth.username]);

  return [applyForm, loading, err];
}
